import { ShadowStyles, Stack } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Menu } from 'native-base';
import React from 'react';
import { View } from 'react-native';

import { SinacorAccount } from '../../../store/customer/types';

import { AccountColumnsHeader } from './AccountColumnsHeader';
import { AccountMenuItem } from './AccountMenuItem';
import { SelectionTrigger } from './SelectionTrigger';

const menuStyle = {
  ...ShadowStyles.Level[1],
  paddingHorizontal: Utils.Token.ToInt(Spacing, 'inline.nano'),
  minWidth: 280,
};

const menuItemStyle = {
  alignSelf: 'stretch' as const,
  borderRadius: Utils.Token.ToInt(BoxRadius, 'sm'),
  overflow: 'hidden' as const,
  paddingHorizontal: 0,
};

interface AccountsSelectionMenuProps {
  accounts: SinacorAccount[];
  selectedAccount: SinacorAccount;
  onSelect: (sinacorAccount: string) => void;
  isMobile?: boolean;
}

export const AccountsSelectionMenu: React.FC<AccountsSelectionMenuProps> = ({
  accounts,
  selectedAccount,
  onSelect,
  isMobile,
}) => {
  const menu = (
    <Menu
      borderRadius={BoxRadius.sm}
      style={menuStyle}
      placement="bottom left"
      trigger={(triggerProps) => (
        <SelectionTrigger triggerProps={triggerProps} account={selectedAccount} />
      )}>
      <Menu.Item isDisabled style={menuItemStyle}>
        <AccountColumnsHeader />
      </Menu.Item>
      {accounts.map((account) => (
        <AccountMenuItem
          key={`${account.custodyAccountNormalized}-${account.sinacorAccountNormalized}`}
          account={account}
          isSelected={account.sinacorAccountNormalized === selectedAccount.sinacorAccountNormalized}
          onSelect={onSelect}
        />
      ))}
    </Menu>
  );

  if (isMobile) {
    return <View>{menu}</View>;
  }

  return (
    <Stack flex={1} pr="inline.nano">
      {menu}
    </Stack>
  );
};
